import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  regenerateContentImages,
  regenerateContentText,
} from "../api/content.api";
import { useToast } from "./ToastContext";

export function useRegenerateImages() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation({
    mutationFn: regenerateContentImages,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["content"] });
      queryClient.invalidateQueries({ queryKey: ["content-list"] });
      showToast("Images regeneration started", "success");
    },
    onError: (err) => {
      console.error("Error regenerating images:", err);
      showToast("Failed to regenerate images", "error");
    },
  });
}

export function useRegenerateText() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation({
    mutationFn: regenerateContentText,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["content"] });
      queryClient.invalidateQueries({ queryKey: ["content-list"] });
      showToast("Text regeneration started", "success");
    },
    onError: (err) => {
      console.error("Error regenerating text:", err);
      showToast("Failed to regenerate text", "error");
    },
  });
}
